import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import DefaultLayout from "./layouts/DefaultLayout";
import SidebarLayout from "./layouts/SidebarLayout/SidebarLayout";
import HeaderOnly from "./layouts/HeaderOnly/HeaderOnly";
import AdminLayout from "./layouts/AdminLayout/AdminLayout";
import { publicRouters } from "./routes";
import NotFound from "./components/Share/not.found";

function App() {
  return (
    <>
      <Router>
        <Routes>
          {publicRouters.map((route, index) => {
            const Page = route.component;
            let Layout: ({ children }: any) => JSX.Element = DefaultLayout;
            if (route.changeLayout === "headerOnly") {
              Layout = HeaderOnly;
            } else if (route.changeLayout === "sidebarLayout") {
              Layout = SidebarLayout;
            } else if (route.changeLayout === "adminLayout") {
              Layout = AdminLayout;
            }
            return (
              <Route
                path={route.path}
                key={index}
                element={
                  <Layout>
                    <Page />
                  </Layout>
                }
              />
            );
          })}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Router>
    </>
  );
}

export default App;
